import { Box, Button, Typography } from '@mui/material';
import React, { FC, MouseEventHandler } from 'react';
import { BigImagesBox, ImageWrapper } from './styled';
import { BrokerRequestTooltip } from '@/components';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import { MediaFile } from '@/types';

const Tour360Modal = dynamic(() =>
  import('./Tour360Block').then((m) => ({ default: m.Tour360Modal })),
);

type MainImageProps = {
  hasVideo: boolean;
  onOpenVideoQuiet: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  onOpenPhotoDetail: (index: number) => void;
  hasMultipleImages: boolean;
  src?: string;
  tourLinks?: MediaFile[];
  image360?: MediaFile[];
  hasInfoRequest?: boolean;
  objectId?: string;
};

export const MainImage: FC<MainImageProps> = ({
  hasVideo,
  onOpenVideoQuiet,
  onOpenPhotoDetail,
  hasMultipleImages,
  src,
  tourLinks,
  image360,
  hasInfoRequest,
  objectId,
}) => {
  const t = useTranslations();

  return (
    <BigImagesBox>
      <ImageWrapper>
        {src && (
          <img
            src={src}
            alt="preview image 1"
            fetchPriority="high"
            onClick={() => onOpenPhotoDetail(0)}
          />
        )}
        {!hasMultipleImages && hasVideo && (
          <Box sx={{ position: 'absolute', bottom: '10px', right: '10px' }}>
            <Button variant="primary" onClick={onOpenVideoQuiet} sx={{ height: '26px' }}>
              <Typography fontSize={14} fontWeight={600} lineHeight="16px">
                {t('housingCardDetails.videoTour')}
              </Typography>
            </Button>
          </Box>
        )}
        <BrokerRequestTooltip objectId={objectId} hasInfoRequest={hasInfoRequest} />
        <Tour360Modal tourLinks={tourLinks} image360={image360} />
      </ImageWrapper>
    </BigImagesBox>
  );
};
